import api from './api';

export interface ExchangeRates {
  EUR: { starsPerUnit: number };
  USD: { starsPerUnit: number };
}

export const ratesApi = {
  getCurrentRates: async (): Promise<ExchangeRates> => {
    const response = await api.get('/rates/current');
    return response.data;
  },
};
